import { Unformatted } from '../../../utils/value.js'
import type * as Style from '../../index.js'
import * as Ruleset from '../../methods/set.js'
import { Keyword, Number, RuleId, ValidatedArray } from '../../values/index.js'

export enum Platform {
  'google' = 'google',
  'adobe' = 'adobe',
  'custom' = 'custom'
}

export enum VariantStyle {
  'normal' = 'normal',
  'italic' = 'italic'
}
const normalizeFontVariant = (variant: any = {}) => ({
  name: String(variant.name),
  familyName: String(variant.familyName),
  weight: Number(variant.weight) ?? 400,
  style: Keyword<VariantStyle>(variant.style, VariantStyle)
})

export type Variant = ReturnType<typeof normalizeFontVariant>
export const FontVariant = (variant: Unformatted<Variant>) => normalizeFontVariant(variant)

export interface VariantReference {
  id: RuleId
  name: string
}

export const VariantReference = (props: Unformatted<VariantReference>) => {
  return props as VariantReference
}

VariantReference.Fix = (fontVariantReference: VariantReference, styles: Style.Rule[]): VariantReference => {
  if (fontVariantReference == null) return null

  if (!('id' in fontVariantReference) || !('name' in fontVariantReference)) return fontVariantReference

  // If it doesn't exist return a color reference with color id the internal color's id.
  const fonts = Ruleset.filterByType(styles, 'font')
  const font = fonts.find((style) => style.details.id === fontVariantReference.id)
  const variant = fonts.find((style) => style.props?.variants?.find((v) => v.name === fontVariantReference.name))

  if (!font) {
    return null
  }

  if (!variant) {
    return font.props?.variants?.length ? { ...fontVariantReference, name: font.props.variants[0].name } : null
  }

  return fontVariantReference
}

export const Props = (props: any = {}) => ({
  familyName: (props.familyName as string) || null,
  platform: Keyword<Platform>(props.platform, Platform),
  variants: ValidatedArray(FontVariant, props.variants)
})
export type Props = ReturnType<typeof Props>
export const fix = (props: Props, styles: Style.Rule[]): Props => {
  //if (!props.familyName) return null

  return props
}
export const validate = () => true
export const type = 'font'
export const category = 'basic'
export const label = 'Font'
export const forms = [
  {
    id: 'font',
    label: 'Font selector',
    extractProperties: (props: Props) => props,
    validate: () => true
  }
]
